<template>
    <div class="header-wrapper whites" id="header">
        <div class="header ">
            <div class="container no-paddings">
                <a class="logo" href="#/">
                    <div class="logo-image">
                        <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" class='stretch'>
                    </div>
                    <!-- <logo-text class="logo-text"/> -->
                    <div class="logo-text-short">
                        {{tr.iwep}}
                    </div>
                </a>
                <ul class="menu">
                    <li class="d-none d-xl-inline-block"><a href="#/">{{tr.home_page}}</a></li>
                    <li class="d-none d-md-inline-block"><a href="#/posts">{{tr.publications}}</a></li>
                    <li class="d-none d-sm-inline-block"><a href="#/events">{{tr.main_events}}</a></li>
                    <!-- <li class="d-none d-lg-inline-block"><a href="#/experts">{{tr.experts}}</a></li> -->
                    <li class="d-none d-lg-inline-block"><a href="#/contacts">{{tr.contacts}}</a></li>
                    <!-- <li class="d-none d-lg-inline-block" v-if="lang!='kz'"><a href="#/library">{{tr.library}}</a></li> -->
                    <li>
                        <a href="#" @click="(e)=>{e.preventDefault();openMenu('lang')}" :class="{active:opened_menu == 'lang'}">
                            <!-- <img src="/dist/ru.svg" width="24px;" style='vertical-align:middle'/> -->{{lang.toUpperCase()}} <span class="fa fa-caret-down" />
                        </a>
                        <div class="lang-menu" v-if="opened_menu == 'lang'">
                            <div @click="setLang('kz')">&nbsp;KZ &nbsp;</div>
                            <div @click="setLang('en')">&nbsp;EN &nbsp;</div>
                            <div @click="setLang('ru')">&nbsp;RU &nbsp;</div>
                        </div>
                    </li>
                    <li>
                        <a @click="(e)=>{e.preventDefault();openMenu('search')}" :class="{active:opened_menu == 'search'}">
                            <div class="fa fa-search"></div>
                        </a>
                    </li>
                    <li class="mobile-menu">
                        <a href="#" @click="(e)=>{e.preventDefault();openMenu('menu')}" :class="{active:opened_menu == 'menu'}">
                            <div class="fa fa-bars"></div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="search-menu" v-if="opened_menu == 'search'">
            <input type="text" placeholder="Введите текст для поиска" v-model="search_query" @keyup="findEnter">
            <button @click="find()">
                <span class="fa fa-search"></span>
                <span class="lbl">Поиск</span>
            </button>
        </div>
        <div class="menu-expanded" v-if="opened_menu == 'menu'" style="{height:menu_opened?'37px':'0px'}" @click="openMenuItem">
            <div class="container">
              <ul>
                <li class="d-inline-block d-xl-none"><a href="#">{{tr.home_page}}</a></li>
                <li class="d-inline-block d-md-none"><a href="#/posts">{{tr.publications}}</a></li>
                <li class="d-inline-block d-sm-none"><a href="#/events">{{tr.main_events}}</a></li>
                <!-- <li class="d-inline-block d-lg-none"  v-if="lang!='kz'"><a href="#/library">{{tr.library}}</a></li> -->
                <!-- <li class="d-inline-block d-lg-none"><a href="#/experts">{{tr.experts}}</a></li> -->
                <li class=""><a href="#/about">{{tr.about_iwep}}</a></li>
                <li class=""><a href="#/multimedia">{{tr.multimedia}}</a></li>
                <li class=""><a href="#/for-media">{{tr.for_media}}</a></li>
                <li class="d-inline-block d-lg-none"><a href="#/contacts">{{tr.contacts}}</a></li>
            </ul>
            </div>
        </div>
        <div class="header-placeholder"></div>
    </div>
</template>
<script>
import LogoText from "./logo-text.vue";
let {_i} = window;
export default {
    name: 'iheader',
    components: { LogoText },
    methods: {
        setLang(lang) {
            this.$store.commit('setLang', lang);
            localStorage.lang = lang;
            _i.seo.load({lang});
            this.opened_menu = false;
        },
        openMenuItem(e) {
            console.log(e.target)
            e.preventDefault();
            location.href = e.target.href;
            this.opened_menu = false;
        },
        openMenu(mn) {
            if (this.opened_menu == mn) this.opened_menu = false;
            else this.opened_menu = mn;
        },
        findEnter(e) {
            if (e.keyCode === 13) {
                this.opened_menu = false;
                this.find();
            }
            //this.opened_menu = false;
        },
        find() {
            location.href = "#/search?q=" + this.search_query;
            this.$store.dispatch("search", this.search_query);
        }
    },
    computed: {
        lang() { return this.$store.state.lang; },
        tr() { return this.$store.getters.translates; }
    },
    data() {
        return {
            search_query: "",
            opened_menu: false,
            logo_black: require('../assets/img/logo_black.png'),
            logo_white: require('../assets/img/logo_white.png'),
            ru_flag: require('../assets/img/flags/ru.svg'),
            kz_flag: require('../assets/img/flags/kz.svg'),
            uk_flag: require('../assets/img/flags/uk.svg'),
            menu_opened: false,
            lang_opened: false
        }
    }
}
</script>
<style lang="css" scoped>
* {
    user-select: none;
}


/*
#1d8fa9
*/


/*HEADER GENERAL*/

.header-wrapper {
    width: 100%;
}

.header-placeholder {
    height: 87px;
}

.header {
    top: 26px;
    width: 100%;
    color: white;
    letter-spacing: 0.05em;
    white-space: nowrap;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    position: fixed;
    min-width: 320px;
    z-index: 11;
}





/*LOGO*/

.logo {
    padding: 9px 14px;
    display: inline-block;
    text-decoration: none;
    color: white;
    cursor: pointer;
    padding-left: 0;
    margin-left:4px;
    float:left;
}

.logo-text {
    display: inline-block;
    line-height: 1;
    vertical-align: middle;
    margin-left: 4px;
    letter-spacing: 0.1em;
}

.logo-text-short {
    /*display: none;*/
    display: inline-block;
    font-family: "Tahoma";
    font-weight: bold;
    font-size: 29px;
    vertical-align: middle;
    margin-left:4px;
}

@media(max-width:528px) {
    .logo-text {
        display: none;
    }
    .logo-text-short {
        display: inline-block;
    }
}







/*MENU*/

.menu {
    display: inline-block;
    float: right;
    vertical-align: top;
    margin: 0;
    font-size: 0;
    padding: 0;
}

.menu li {
    display: inline-block;
}

.menu li a {
    color: white;
    text-decoration: none;
    transition: 0.3s background ease;
    background: rgba(255, 255, 255, 0);
    font-size: 16px;
    border-left: 0.5px solid rgba(0, 0, 0, 0.1);
    border-right: 0.5px solid rgba(0, 0, 0, 0.1);
    display: inline-block;
    list-style: none;
    text-transform: uppercase;
    padding: 24px 12px;
}

.menu li a:hover {
    background: rgba(255, 255, 255, 0.18);
    cursor: pointer;
}

.menu li a:active,
.menu li a.active {
    background: rgba(0, 0, 0, 0.2);
}

.menu-expanded li:nth-child(4),
.menu-expanded li:nth-child(3),
.menu-expanded li:nth-child(2) {
    display: none;
}

@media(max-width:992px) {
    .menu li:nth-child(3) {
        display: none;
    }
    .menu-expanded li:nth-child(4),
    .menu-expanded li:nth-child(5) {
        display: inline-block;
    }
}

@media(max-width:908px) {
    .menu li:nth-child(4) {
        display: none;
    }
    .menu-expanded li:nth-child(5) {
        display: inline-block;
    }
}

@media(max-width:767px) {
    .menu li:nth-child(2),
    .menu li:nth-child(1) {
        display: none;
    }
    .menu-expanded li:nth-child(3),
    .menu-expanded li:nth-child(2) {
        display: inline-block;
    }
}

@media(max-width:667px) {
    .menu li:nth-child(1) {
        display: none;
    }
    .menu-expanded li:nth-child(2) {
        display: inline-block;
    }
    .menu-expanded a,
    .menu-expanded li {
        width: 100%;
    }
}


@media(max-width:396px) {
    .menu li:nth-child(7) {
        /*display: none;*/
    }
}

@media(max-width:331px) {
    .menu li:nth-child(5) {
        display: none;
    }
}











.menu-expanded {
    position: fixed;
    width: 100%;
    background: rgba(35, 91, 146, 0.67);
    top: 93px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    text-align: center;
    transition: 0.3s height ease;
    overflow: hidden;
    z-index: 9;
}

.menu-expanded ul {
    margin: 0;
}

.menu-expanded ul li a {
    color: white;
    text-decoration: none;
    padding: 12px 12px;
    display: inline-block;
    transition: 0.3s background ease;

    border-left: 0.5px solid rgba(0, 0, 0, 0.1);
    border-right: 0.5px solid rgba(0, 0, 0, 0.1);
    font-size: 14px;
    text-transform: uppercase;
}

.menu-expanded ul li a:hover {
    background: rgba(255, 255, 255, 0.18);
}

.menu-expanded ul li {
    list-style: none;
    display: inline-block;
}





.lang-menu {
    position: fixed;
    background: #092e55;
    /*z-index: 9999;*/
}

.lang-menu>div {
    padding: 24px;
    color: white;
    font-size: 14px;
}

.lang-menu>div:hover {
    background: rgba(255, 255, 255, 0.18);
    cursor: pointer;
}



.search-menu {
    padding: 16px 16px;
    top: 93px;
    position: fixed;
    width: 50%;
    right: 0;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    background: rgba(35, 91, 146, 0.67);
    z-index: 999;
}

.search-menu input {
    width: 70%;
    border-radius: 4px;
    border: 1px solid lightgrey;
    padding: 6px 12px;
    vertical-align: top;
}

.search-menu button {
    padding: 6px 8px;
    border-radius: 4px;
    float: right;
    width: 29%;
    margin-left: 1%;
    vertical-align: top;
    cursor: pointer;
}

@media(max-width:700px) {
    .search-menu {
        width: 100%;
    }
}


/*WHITE THEME*/

.header-wrapper.white .menu li a,
.header-wrapper.white .menu-expanded li a {
    color: black;
}

.header-wrapper.white .header,
.header-wrapper.white .menu-expanded {
    color: black;
    background: white;
}

.header-wrapper.white .menu-expanded ul li a:hover,
.header-wrapper.white .menu li a:hover {
    background: rgba(0, 0, 0, 0.08);
}

.header-wrapper.white .logo-image {
    background-image: url(/dist/logo_black.png);
}

ul {
    padding: 0;
}
</style>